import React from "react";
import { Formik } from "formik";
import {
  MimaButton,
  MimaDropdown,
  MimaInput,
  MimaMultiPaginatedDropdown,
  MimaText,
  Modal,
} from "../../components";

const ChangeRate = ({
  rateModal,
  loading,
  onSubmit,
  closeModal,
  currencyCodes,
  validationSchema,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" align="center" mb="7">
        Change Rate
      </MimaText>
      <Formik
        initialValues={{
          fromCurrency: "",
          toCurrency: "",
          ngnRate: "",
          maxMarketRate: "",
          minMarketRate: "",
          moneyExRate: "",
          businesses: [],
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <div>
            <MimaMultiPaginatedDropdown
              labelTitle="Businesses(Optional)"
              name="businesses"
              id="businesses"
              value={values.businesses}
              placeholder="Select Businesses"
              currentValue={values.businesses}
              onChange={(data) => {
                setFieldValue("businesses", data);
              }}
              touched={touched.businesses}
              error={errors.businesses}
              queryKey={["getAllSignedBusinesses"]}
              optionLabel="tradingName"
              url="/businesses"
              getPageValue={(page) => page?.data?.businesses || []}
              getPageTotalCount={(lastPage) => lastPage?.data?.count || 0}
              variant="medium"
            />
            <div className="modal__beside">
              <MimaDropdown
                labelTitle="Currency From"
                variant="filterForm"
                name="fromCurrency"
                placeholder="Select Currency"
                data={currencyCodes}
                value={values.fromCurrency}
                currentValue={values.fromCurrency}
                onChange={(data) => {
                  setFieldValue("fromCurrency", data.key);
                }}
                onBlur={handleBlur}
                error={errors.fromCurrency}
                touched={touched.fromCurrency}
                width={18}
              />
              <MimaDropdown
                labelTitle="Currency To"
                variant="filterForm"
                name="toCurrency"
                placeholder="Select Currency"
                data={currencyCodes}
                value={values.toCurrency}
                currentValue={values.toCurrency}
                onChange={(data) => {
                  setFieldValue("toCurrency", data.key);
                }}
                onBlur={handleBlur}
                error={errors.toCurrency}
                touched={touched.toCurrency}
                width={18}
              />
            </div>
            <div className="modal__beside">
              <MimaInput
                labelTitle="New Rate"
                variant="form2"
                name="ngnRate"
                type="number"
                value={values.ngnRate}
                placeholder="Enter Rate"
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.ngnRate}
                touched={touched.ngnRate}
                width={18}
              />
              <MimaInput
                labelTitle="Money-Ex Rate"
                variant="form2"
                name="moneyExRate"
                type="number"
                value={values.moneyExRate}
                placeholder="Enter Money-Ex Rate"
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.moneyExRate}
                touched={touched.moneyExRate}
                width={18}
              />
            </div>
            <div className="modal__beside">
              <MimaInput
                labelTitle="Max Market Rate"
                variant="form2"
                name="maxMarketRate"
                type="number"
                value={values.maxMarketRate}
                placeholder="Enter Max Market Rate"
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.maxMarketRate}
                touched={touched.maxMarketRate}
                width={18}
              />
              <MimaInput
                labelTitle="Min Market Rate"
                variant="form2"
                name="minMarketRate"
                type="number"
                value={values.minMarketRate}
                placeholder="Enter Min Market Rate"
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.minMarketRate}
                touched={touched.minMarketRate}
                width={18}
              />
            </div>
            <MimaButton
              title="Save"
              width={38}
              // buttonColor="var(--color-dark)"
              onClick={handleSubmit}
              loading={loading}
            />
          </div>
        )}
      </Formik>
    </Modal>
  );
};
export default ChangeRate;
